<template>
  <el-dialog
    v-model="visible"
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    :close-on-click-modal="false"
    class="border-radius-20"
  >
    <div class="container-fuild">
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="s-32 fw-500 text-center text-black">
            🚀 New Communication Module
          </div>
        </div>
      </div>
      <p class="text-dak mb-4">
        We have launched a brand new communication system with improved
        performance and additional channels.
      </p>

      <div class="row text-center">
        <div class="col-6 mb-3">
          <div class="card p-3 shadow-sm">
            <h6 class="text-dak">SMS</h6>
            <small class="text-muted"
              >Faster delivery and improved reliability</small
            >
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="card p-3 shadow-sm">
            <h6 class="text-dak">Email</h6>
            <small class="text-muted">Better email delivery system</small>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="card p-3 shadow-sm">
            <h6 class="text-dak">Voice</h6>
            <small class="text-muted">Enhanced voice broadcast</small>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="card p-3 shadow-sm">
            <h6 class="text-dak">WhatsApp</h6>
            <small class="text-muted">Seamless WhatsApp messaging</small>
          </div>
        </div>
      </div>

      <div class="alert alert-success mt-3">
        ✅ All communication issues have been resolved in the new application.
      </div>
    </div>

    <template #footer>
      <div class="d-flex justify-content-end w-100">
        <el-button round class="secondary-button" @click="closeModal">
          Continue here
        </el-button>

        <el-button round class="text-white primary-bg" @click="goToNewApp">
          Try New Communication
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { ref, onMounted } from "vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";

const visible = ref(false);
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();

const NEW_APP_URL = "https://churchplus-unicorn.vercel.app/";

const closeModal = () => {
  visible.value = false;
  localStorage.setItem("communicationFeatureSeen", "true");
};

const goToNewApp = () => {
  localStorage.setItem("communicationFeatureSeen", "true");
  window.open(NEW_APP_URL, "_blank");
};

onMounted(() => {
  window.addEventListener("show-new-communication-modal", () => {
    visible.value = true;
  });
});
</script>
